export const LayoutConstants = {
  DEFAULT_CONTENT_WIDTH: 1280,
  MIN_CONTENT_WIDTH: 1024
}
